import React from 'react';
import { Typography, withStyles } from '@material-ui/core';

const styles = {
  wrapper: {
    marginTop: '38px',
    marginBottom: '16px',
  },
  title: {
    margin: '0',
  },
  subTitle: {
    color: '#202020',
    margin: '21px 0 0',
  },
};

const CreateHeader = (props) => {
  const { title, subTitle, classes } = props;
  return (
    <div className={classes.wrapper}>
      <Typography variant="h5" className={classes.title}>
        {title}
      </Typography>
      {subTitle ?
        <Typography variant="subtitle1" className={classes.subTitle}>
          {subTitle}
        </Typography>
        : null}
    </div>
  );
};

export default withStyles(styles)(CreateHeader);
